var React = require('react');

function Auto (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h20v20H0z","key":0}),React.createElement("path",{"d":"M9.967 10.911s-5.483 0-5.483 4.386a47.273 47.273 0 0 1 2.055-1.15c.962-.507 2.113-1.007 3.428-1.007s2.526.493 3.488 1.006a47.3 47.3 0 0 1 2.054 1.151c.013-4.254-5.502-4.386-5.542-4.386Z","fill":"#fff","key":1}),React.createElement("path",{"d":"M17.27 13.462 11.052 4.56A1.244 1.244 0 0 0 10.007 4c-.386 0-.78.171-1.06.559L2.73 13.462a1.307 1.307 0 0 0 .314 1.802c.589.42 1.394.276 1.806-.316 1.825-2.623 3.448-3.88 5.149-3.78 1.695-.1 3.317 1.157 5.15 3.78a1.294 1.294 0 0 0 1.805.316c.576-.414.72-1.21.314-1.802Z","fill":"#fff","key":2})]);
}

Auto.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Auto;

Auto.default = Auto;
